export { default } from './SidePanelPlaceholder';
